import Cookies from 'js-cookie';

function purchaseController($scope, $http, $rootScope, $route, $timeout, SiteWinnersSvc, NextDrawSvc, DrawsSvc, PlansSvc, $location, $routeParams, ctapickacardSvc, $translate, TicketHandlerSvc) {
  'ngInject';

  DrawsSvc.get({}, function (data) {
    $scope.Draws = data;
  });

  //show larger purpchase prompt
  //$scope.Prompt = false;
  $scope.Purchases = [];
  $scope.Deck = [];
  $scope.TotalCost = 0;
  $scope.TotalTickets = 0;
  $scope.Processing = false;
  $scope.DrawsSelected = 1;

  jQuery(document).ready(function ($) {

    $('.purchase-options').fadeIn(300);

    $http.get(TFL_Base_Url + 'plans/getMinimumPurchase?ApiKey=' + Cookies.get('TLF_Auth_Token') + '&OrganizationId=' + TFL_ID).then(function (data) {
        $scope.MinimumPurchaseAmount = data.data.AmountWithExistingCartItems;
        $scope.MinimumPurchaseAmountDisplay = data.data.MinimumPurchaseAmount
        //$scope.minPurchaseNotReached = data.data.MinPurchaseEnabled;
    });

    if (window.location.pathname.split('/')[1] == "renew-tickets") {
      if (TicketHandlerSvc.getTickets().length == 0) {
        $location.url($location.path('/tickets').replace());
        $location.path('/tickets').replace();
      }
    }

    if (window.location.pathname.split('/')[1] == "purchase") {
      PlansSvc.get({ ApiKey: Cookies.get('TLF_Auth_Token'), OrganizationId: TFL_ID }, function (data) {
        $scope.Plans = data;
        if ($scope.Plans.length < 1) {
          $scope.SoldOut = true
          NextDrawSvc.get({}, function (data) {
            $scope.NextDrawDate = data.NextDrawDate;
          })
        }
      });
    }

    if (Cookies.get('TLF_Auth_Token') == undefined) {
      var date = new Date();
      var minutes = 60000;
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      Cookies.set('TLF_LastPage', $location.$$path, { expires: date });
      $location.path('/connect').replace();
      $route.reload();
    }

    if($rootScope.SiteDetails.GameType == 'chase-the-ace'){
      ctapickacardSvc.get({ OrganizationId: TFL_ID }, function (data) {
        $scope.Deck = data;
      });
    }
  });

  //$scope.CheckLimits = function (Index, Units, Cost) {
    
  //  if ($scope.ShowUpDown) {
  //    document.getElementById("ticketDeal" + Index).classList.add('unclickable'); //Keep increase button from being clicked until it's determined if more tickets can be bought
  //    var numTickets = parseInt(document.getElementById("numberOfTickets" + Index).value) + 1
  //    $http.get(TFL_Base_Url + 'plans/checkLimitations?ApiKey=' + Cookies.get('TLF_Auth_Token') +'&Id=' + TFL_ID + '&Cost=' + Cost + '&Units=' + Units + '&NumTickets=' + numTickets).then(function (data) {
  //      if (data.data == true) //remove increase option
  //        document.getElementById("ticketDeal" + Index).classList.add('disableIncrease');

  //      document.getElementById("ticketDeal" + Index).classList.remove('unclickable') //Allow increase button to be clicked again

  //      if ($scope.PreviousIndex != Index) { //add increase option back in for previous plan
  //        if ($scope.PreviousIndex !== undefined)
  //          document.getElementById("ticketDeal" + $scope.PreviousIndex).classList.remove('disableIncrease')
  //        $scope.PreviousIndex = Index
  //      }
  //    });      
  //  }
    

  //}

  //$scope.RemoveClass = function (Index) {
  //  document.getElementById("ticketDeal" + Index).classList.remove('disableIncrease');
  //}

  $scope.UpdateSelections = function (Index, PlanId, NumberOfTickets, Cost, Units, Type) {
      //Gets id for div of current plan
      var id = 'numberOfTickets' + Index;

      //If not trying to remove from a plan of 0
      if (document.getElementById(id).value > 0 || Type == "add") {

          //Updates UI for number of times a plan is selected
          if (Type == "add")
              document.getElementById(id).value++;
          else
              document.getElementById(id).value--;

          //Object for each purchase selected
          $scope.Purchase = {
              PlanID: PlanId,
              NumberOfTickets: NumberOfTickets,
              NumberOfTimesSelected: 1,
              Cost: Cost,
              NumberOfWeeks: Units,
              MemberTicketId: null
          }

          //If type is 'remove', find planid in array and remove it
          if (Type == 'remove') {
              var found = false;
              var foundIndex = 0;

              $scope.Purchases.forEach(function (purchase, index) {
                  if (purchase.PlanID == PlanId && !found) {
                      foundIndex = index;
                      found = true;

                      $scope.Purchases.at(foundIndex).NumberOfTimesSelected--;
                  }
              });

              if (found && $scope.Purchases.at(foundIndex).NumberOfTimesSelected == 0) {
                  $scope.Purchases.splice(foundIndex, 1);
              }
          }
          else //Else, if type is 'add', push purchase to array
          {
              var found = false;
              var foundIndex = 0;

              $scope.Purchases.forEach(function (purchase, index) {
                  if (purchase.PlanID == PlanId && !found) {
                      foundIndex = index;
                      found = true;

                      $scope.Purchases.at(foundIndex).NumberOfTimesSelected++;
                  }
              });

              if(!found)
                $scope.Purchases.push($scope.Purchase)
          }

          //Update Cart Preview totals
          $scope.UpdateCartPreview()
      }
  }

  $scope.CheckInputVal = function () {

    if (document.getElementById("inputVal").value > $rootScope.SiteDetails.DrawsRemaining) {
      document.getElementById("inputVal").value = $rootScope.SiteDetails.DrawsRemaining
      document.getElementById("sliderVal").value = $rootScope.SiteDetails.DrawsRemaining
    }
    else if (document.getElementById("inputVal").value < 0) {
      document.getElementById("inputVal").value = 1
      document.getElementById("sliderVal").value = 1   
    }

    //Update Cart Preview totals
    $scope.UpdateCartPreview()
  }

  $scope.UpdateCartPreview = function () {
      $scope.LimitationError = false;
      if ($rootScope.SiteDetails.GameType == 'Modified5050') {
        if($rootScope.SiteDetails.isPurchaseIntoFuture == true)
            $scope.TotalDraws = parseInt(document.getElementById("inputVal").value)
        else
            $scope.TotalDraws = 1
        if (!$scope.TotalDraws) 
        {
            $scope.TotalDraws = 1
        }
          $scope.TotalCost = $scope.Purchases.reduce((n, { Cost, NumberOfTimesSelected }) => n + (Cost * NumberOfTimesSelected * $scope.TotalDraws), 0)
      }
      else
          $scope.TotalCost = $scope.Purchases.reduce((n, { Cost, NumberOfTimesSelected, NumberOfWeeks }) => n + (Cost * NumberOfTimesSelected * NumberOfWeeks), 0)

      $scope.TotalTickets = $scope.Purchases.reduce((n, { NumberOfTickets, NumberOfTimesSelected }) => n + (NumberOfTickets * NumberOfTimesSelected), 0)

      var label = document.getElementById("MinimumPurchaseLabel")
      if ($scope.MinimumPurchaseAmount != null) {
          if ($scope.MinimumPurchaseAmount <= $scope.TotalCost) {
              $scope.minPurchaseNotReached = false;
              label.classList.remove("showTip");
              label.classList.remove("minPurchaseDisable");
          }
          else {
              $scope.minPurchaseNotReached = true;
              label.classList.add("showTip");
              label.classList.add("minPurchaseDisable")

              if ($scope.TotalCost == 0)
                  $scope.minPurchaseNotReached = false;
          }
      }
      
      var btn = document.getElementsByClassName("btncheckout")
      var nav = document.getElementsByClassName("sticky-nav")

      if ($scope.Purchases.length == 0) {
          btn[0].classList.add('disabled');
          nav[0].classList.add('disabled');
      }
      else {
          btn[0].classList.remove('disabled');
          nav[0].classList.remove('disabled');
      }
  }

  $scope.ClearDeals = function () {
    $scope.LimitationError = false;
    $scope.Purchases = []

    var btn = document.getElementsByClassName("btncheckout")
    var nav = document.getElementsByClassName("sticky-nav")

    btn[0].classList.add('disabled');
    nav[0].classList.add('disabled');    

    document.querySelectorAll('[id^="numberOfTickets"]').forEach(function (index) {
        document.getElementById(index.id).value = 0;
    });

    document.getElementById("inputVal").value = 1
    document.getElementById("sliderVal").value = 1

    //Update Cart Preview totals
    $scope.TotalCost = 0
    $scope.TotalDraws = 0
    $scope.TotalTickets = 0
  }

  $scope.LimitationsErrorMessage1 = ''
  $scope.LimitationsErrorMessage2 = ''
  $scope.LimitAmount = 0.0
  $scope.LimitationError = false;
  $scope.LimitIsDollar = false;
  $scope.LimitIsTickets = false;
  $scope.CheckLimitations = function (){
      if ($scope.MinimumPurchaseAmount <= $scope.TotalCost || $scope.MinimumPurchaseAmount == null) {
          $scope.LimitationError = false;
          $scope.LimitIsDollar = false;
          $scope.LimitIsTickets = false;
          //Check if purchase is within limitations set by organization
          $http.get(TFL_Base_Url + 'cart/checkLimitations?ApiKey=' + Cookies.get('TLF_Auth_Token') + '&OrgId=' + TFL_ID + '&PurchaseDollarAmount=' + $scope.TotalCost + '&PurchaseTicketsAmount=' + $scope.TotalTickets).then(function (data) {
              if (data.data.CanProceed == true)
                  $scope.CheckOut();
              else {
                  $scope.LimitationError = true;
                  $scope.LimitationsErrorMessage1 = data.data.ErrorMessage1
                  $scope.LimitationsErrorMessage2 = data.data.ErrorMessage2
                  $scope.LimitAmount = data.data.MaxAmount
                  if (data.data.Type == 'tickets')
                      $scope.LimitIsTickets = true
                  else
                      $scope.LimitIsDollar = true
              }

          }, function (response) {
              //Display General Error?
          });
      }
      else {

      }
  }

  $scope.CheckOut = function () {
    //if ($scope.MinimumPurchaseAmount <= $scope.TotalCost || $scope.MinimumPurchaseAmount == null) {
      $scope.Processing = true;
      if ($rootScope.SiteDetails.GameType != 'chase-the-ace')
      {
          var numOfDraws = 1
          if (document.getElementById("inputVal") != null)
              numOfDraws = parseInt(document.getElementById("inputVal").value)

        $http.post(TFL_Base_Url + "cart/add?ApiKey=" + Cookies.get('TLF_Auth_Token') + "&NumberOfDraws=" + numOfDraws + "&OrganizationCardId=", $scope.Purchases).then(function (data) {
          $location.url($location.path('/checkout').replace());
          $location.path('/checkout').replace();
        }, function (response) {
          //Display Error*******
          $scope.Processing = false;
        });
        
        Cookies.set('TLF_ItemsInCart', true); //set as true for logic around reminder snackbar
      }
      else
      {
        //cta choose card
        history.replaceState($scope.Purchases, 'Select Card', '/select-card');
      }
    //}
  }

  $scope.CheckOutCTA = function(){
    $scope.Processing = true;
    $http.post(TFL_Base_Url + "cart/add?ApiKey=" + Cookies.get('TLF_Auth_Token') + "&NumberOfDraws=1&OrganizationCardId=" + $scope.SelectedId, $scope.Purchases).then(function (data) {
      $location.url($location.path('/checkout').replace());
      $location.path('/checkout').replace();
    }, function (response) {
      //Display Error*******
      $scope.Processing = false;
    });
  }

  $scope.ChooseCard = function () {
    if (this.card.drawn != true) {
      $scope.Purchases = history.state
      $scope.TotalCost = $scope.Purchases.reduce((n, { Cost, NumberOfTimesSelected, NumberOfWeeks }) => n + (Cost * NumberOfTimesSelected * NumberOfWeeks), 0)
      $scope.TotalTickets = $scope.Purchases.reduce((n, { NumberOfTickets, NumberOfTimesSelected }) => n + (NumberOfTickets * NumberOfTimesSelected), 0)

      angular.forEach($scope.Deck, function (c, i) {
        c.chosen = false;
      });
      this.card.chosen = true;
      $scope.SelectedNumber = this.card.num;
      $scope.SelectedId = this.card.id;
      
      var nav = document.getElementsByClassName("sticky-nav")
      nav[0].classList.remove('disabled');              
    }
  }

  if (window.location.pathname.split('/')[1] == "purchase") {
    TicketHandlerSvc.clearTickets()
  }

  $scope.ShowUpDown = true;
  if (TicketHandlerSvc.getTickets().length > 0) {
    $scope.ShowUpDown = false;

    var skip = TicketHandlerSvc.getTickets()[0].DrawsRemaining;
      var SelectedTickets = 0;
    for (var i = 0; i < TicketHandlerSvc.getTickets().length; i++) {
        if (TicketHandlerSvc.getTickets()[i].DrawsRemaining < skip) {
            skip = TicketHandlerSvc.getTickets()[i].DrawsRemaining
            SelectedTickets = 0;
        }
        if (TicketHandlerSvc.getTickets()[i].DrawsRemaining == skip)
        SelectedTickets++;
    }
    $scope.ShowError = false;
    $http.get(TFL_Base_Url + 'plans/checkLimitationsRenew?ApiKey=' + Cookies.get('TLF_Auth_Token') + '&OrganizationId=' + TFL_ID + '&SelectedTickets=' + SelectedTickets + "&skipDraws=" + skip).then(function (data) {
        $scope.Plans = data.data
      if ($scope.Plans.length == 0)
        $scope.ShowError = true;
    });
  }
};

export default {
  name: 'purchaseController',
  fn: purchaseController
}